module.exports = __webpack_public_path__ + "img/join2-zh.3c528601.jpg";